import { Vector2 } from 'three';

export interface VirtualElement {
  getBoundingClientRect(): DOMRect;
}

export class NormalizedPointer extends Vector2 {
  private elem: VirtualElement;

  constructor(
    elem: VirtualElement = {
      getBoundingClientRect: () => new DOMRect(),
    }
  ) {
    super();
    this.elem = elem;
  }

  updateFromEvent(evt: PointerEvent) {
    const rect = this.elem.getBoundingClientRect();

    this.x = ((evt.clientX - rect.left) / rect.width) * 2 - 1;
    this.y = (-(evt.clientY - rect.top) / rect.height) * 2 + 1;
  }
}

export default NormalizedPointer;
